import {
  DefragOption,
  InstallApplication,
  RemovableMedia,
  RunApplication,
  SystemRestore,
  WindowServices,
} from "js/includes/components/scripting/ScriptsSelector/ParameterModal/ParameterComponents"
import { localized } from "js/includes/common/utils"

function getCredentialType(value) {
  switch (value) {
    case "system":
      return localized("general.system")
    case "loggedonuser":
      return localized("editors.credentials.currentLoggedOnUser")
    case "SR_LOCAL_ADMINISTRATOR":
      return localized("editors.credentials.preferredWindowsLocalAdmin")
    case "SR_DOMAIN_ADMINISTRATOR":
      return localized("editors.credentials.preferredWindowsDomainAdmin")
    default:
      return localized("editors.credentials.preferredCredential")
  }
}

const windowsNativeScripts = [
  {
    id: "7202FA90-73EE-4854-981A-C29954138E8E",
    name: "editors.policy.actions.EnableCDROMDrives",
    categoryId: 3,
  },
  {
    id: "89BF9801-BF0F-4CEB-B9AC-DC5192D031A1",
    name: "editors.policy.actions.DisableCDROMDrives",
    categoryId: 3,
  },
  {
    id: "C41A7050-821E-4E99-8910-DCD9A73628CA",
    name: "editors.policy.actions.EnableUSBDrives",
    categoryId: 3,
  },
  {
    id: "5CBC65F9-F039-4165-AF74-5128952B4E72",
    name: "editors.policy.actions.DisableUSBDrives",
    categoryId: 3,
  },
  {
    id: "4E1EC53D-84C1-4DCD-A4B9-ADAA9B1072C6",
    name: "editors.policy.actions.EnableFloppyDrive",
    categoryId: 3,
  },
  {
    id: "38A80C81-46A0-4BCD-9CFD-035279F5D6A7",
    name: "editors.policy.actions.DisableFloppyDrive",
    categoryId: 3,
  },
  {
    id: "1F438DE8-328F-4CE8-B81E-A91C4A439CBB",
    name: "editors.policy.actions.FixRebuildPerformanceCounters",
    categoryId: 3,
  },

  {
    id: "679FDE5E-5DFC-4B19-9CE9-5057BF7E0285",
    name: "editors.policy.actions.GroupPolicyForceUpdate",
    categoryId: 3,
  },
  {
    id: "3800e62f-9e9d-4193-8b59-4cc4d1465020",
    name: "editors.policy.actions.ClearDnsCache",
    categoryId: 3,
  },
  {
    id: "fabfc3e2-d408-4e5d-a733-cfc43dca3761",
    name: "editors.policy.actions.ClearEventLogs",
    categoryId: 3,
  },
  {
    id: "680caf8e-d7f5-4a93-ad47-cd801229eed0",
    name: "editors.policy.actions.DeleteTempFiles",
    categoryId: 3,
  },
  {
    id: "82e25a31-0245-487e-8a77-362be992716d",
    name: "editors.policy.actions.EmptyRecycleBin",
    categoryId: 3,
  },
  {
    id: "2e59fcd5-d36a-4e69-8da4-68ec8abdf041",
    name: "editors.policy.actions.CheckDisk",
    categoryId: 3,
  },
  {
    id: "540150c3-3f1a-461a-a599-052bfb8d47d2",
    name: "editors.policy.actions.IpReleaseRenew",
    categoryId: 3,
  },
  {
    id: "826ece58-2e36-432c-8188-5e6fa31c231c",
    name: "editors.policy.actions.WindowsCleanup",
    categoryId: 3,
  },
  {
    id: "C4CB6876-F9D2-41FC-B53F-A8EC58A994FA",
    name: "editors.policy.actions.SFCScannow",
    categoryId: 3,
  },
  {
    id: "7f72d612-463e-4fac-b6ed-435b9c568ce9",
    name: "editors.policy.actions.Reboot",
    categoryId: 3,
  },
  {
    id: "e2b5f0f4-0774-43fa-86ec-3ccf4bdf5915",
    name: "editors.policy.actions.ForcedReboot",
    categoryId: 3,
  },
  {
    id: "B85D8E13-C5CD-4662-8490-AEBED6F8E059",
    name: "editors.policy.actions.RebootPending",
    categoryId: 3,
  },
  {
    id: "B6746C96-D1BE-482E-8FC8-58C4387954BC",
    name: "editors.policy.actions.EnableUAC",
    categoryId: 3,
  },
  {
    id: "4C7B01C1-0747-4618-8049-D22446C394B8",
    name: "editors.policy.actions.DisableUAC",
    categoryId: 3,
  },
  {
    id: "2139e58a-5765-4ea5-bf60-e6e6963eabd4",
    name: "editors.policy.actions.LogOff",
    categoryId: 3,
  },
  {
    id: "14FD52EC-D8DC-413D-A7A7-C5796D67AFCD",
    name: "editors.policy.actions.RemoveGoogleToolbar",
    categoryId: 3,
  },
  {
    id: "D2528180-87B8-46A3-86F0-AB9AED0A7204",
    name: "editors.policy.actions.RemoveYahooToolbar",
    categoryId: 3,
  },
  {
    id: "a8c2658d-add7-49fa-92f1-caa7e0daf656",
    name: "editors.policy.actions.Defrag",
    categoryId: 3,
    parameterComponent: DefragOption,
    scriptName: (name, { volumeName, checkList }) => {
      let option = ""

      if (volumeName === "BOOT_VOLUME") {
        option =
          checkList === "INCLUDE"
            ? localized("editors.policy.actions.bootVolume")
            : localized("editors.policy.actions.excludingVolume")
      } else if (volumeName === "BOOT_AND_RECOVERY_VOLUMES") {
        option = localized("editors.policy.actions.excludeRecovery")
      } else {
        option = localized("editors.policy.actions.allVolumes")
      }

      return `${name} ${option}`
    },
    parameters: { volumeName: "ALL_VOLUMES", checkList: "INCLUDE" },
  },
  {
    id: "258836d1-5aa1-424e-900a-20cf22b228a3",
    name: "editors.policy.actions.MediaEnableDisable",
    categoryId: 3,
    parameterComponent: RemovableMedia,
    scriptName: (name, { enabled }) => `${localized(enabled ? "general.enable" : "general.disable")} ${name}`,
    parameters: { enabled: false },
  },
  {
    id: "e027f5a2-9182-4ea0-8f01-867eb299afd3",
    name: "editors.policy.actions.RunApplication",
    categoryId: 3,
    parameterComponent: RunApplication,
    scriptName: (name, { supportedArchitecture, appName, exePath, cmdLineParameters, runAs }) =>
      `${getCredentialType(runAs)} ${name} '${appName}' ${localized("general.from")} '${exePath}' ${localized(
        "general.on",
      )} ${supportedArchitecture} OS`,
    parameters: { runAs: "system", supportedArchitecture: "ALL" },
  },
  {
    id: "73b61bdb-8db2-4f54-8546-a194aef954da",
    name: "editors.policy.actions.Application",
    categoryId: 3,
    parameterComponent: InstallApplication,
    scriptName: (name, { supportedArchitecture, appName, msiUrlPath, cmdLineParameters, runAs }) =>
      `${getCredentialType(runAs)} ${name} '${appName}' ${localized("general.from")} '${msiUrlPath}' ${localized(
        "general.on",
      )} ${supportedArchitecture} OS`,
    parameters: { runAs: "system", supportedArchitecture: "ALL", install: true },
  },
  {
    id: "7dd142b2-ce16-44ff-a1d6-de2c1baa1749",
    name: "editors.policy.actions.WindowsService",
    categoryId: 3,
    parameterComponent: WindowServices,
    scriptName: (name, { start, serviceName }) =>
      `${localized(start ? "general.start" : "general.stop")} ${name} '${serviceName}'`,
    parameters: { start: true },
  },
  {
    id: "2fed9333-c4fd-4e6b-9913-375a8d181376",
    name: "editors.policy.actions.SystemRestore",
    categoryId: 3,
    parameterComponent: SystemRestore,
    scriptName: (name, { enabled }) => `${localized(enabled ? "general.turnOn" : "general.turnOff")} ${name}`,
    parameters: { enabled: true },
  },
]

export default windowsNativeScripts
